const DISPLAY_PROGRESS = 'DISPLAY_PROGRESS';
const HIDE_PROGRESS = 'HIDE_PROGRESS';
const GET_EMPLOYEES = 'GET_EMPLOYEES';
const SELECT_EMPLOYEE = 'SELECT_EMPLOYEE';
const GET_SUMMARY = 'GET_SUMMARY';
const SET_USERS = 'SET_USERS';
const SELECT_USER = 'SELECT_USER';
const SET_EMPLOYEE_CURRENT_ACTION = 'SET_EMPLOYEE_CURRENT_ACTION';
const SET_EMPLOYEE_INFO = 'SET_EMPLOYEE_INFO';
const SET_EMPLOYEE_MOVE_DETAILS = 'SET_EMPLOYEE_MOVE_DETAILS';
const SET_MOVE_TIMELINE = 'SET_MOVE_TIMELINE';
const SET_CONTENT_DATA_LOADING = 'SET_CONTENT_DATA_LOADING';
const SET_USERS_DATA_LOADING = 'SET_USERS_DATA_LOADING';
const SET_USER_CURRENT_ACTION = 'SET_USER_CURRENT_ACTION';
const SET_USER_INFO = 'SET_USER_INFO';
const SET_CONTENT_SUMMARY_LOADING = 'SET_CONTENT_SUMMARY_LOADING';
const SET_LOGGED_IN_USER_DETAILS = 'SET_LOGGED_IN_USER_DETAILS';
const SET_TICKET_REQUEST_DETAILS = 'SET_TICKET_REQUEST_DETAILS';
const SET_TICKET_TIMELINE = 'SET_TICKET_TIMELINE';
const SET_SHORT_STAY_REQUEST_DETAILS = 'SET_SHORT_STAY_REQUEST_DETAILS';
const SET_SHORT_STAY_TIMELINE = 'SET_SHORT_STAY_TIMELINE';
const SET_AIRPORT_TRANSFER_REQUEST_DETAILS =
  'SET_AIRPORT_TRANSFER_REQUEST_DETAILS';
const SET_AIRPORT_TRANSFER_TIMELINE = 'SET_AIRPORT_TRANSFER_TIMELINE';
const SET_REDIRECT_PATH = 'SET_REDIRECT_PATH';
const SET_AUTH_STATE = 'SET_AUTH_STATE';
const SET_ACCOUNT_SETTINGS = 'SET_ACCOUNT_SETTINGS';
const SET_MOVE_TRACK_PATH = 'SET_MOVE_TRACK_PATH';
const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA';
const SET_DASHBOARD_DATA_LOADING = 'SET_DASHBOARD_DATA_LOADING';
const SET_BULK_UPLOAD_STATUS = 'SET_BULK_UPLOAD_STATUS';

export const AUTH_USER_ACTIONS = {
  SET_REDIRECT_PATH,
  SET_AUTH_STATE,
  SET_LOGGED_IN_USER_DETAILS,
  SET_ACCOUNT_SETTINGS,
};

export const APP_SHELL_ACTIONS = {
  DISPLAY_PROGRESS: DISPLAY_PROGRESS,
  HIDE_PROGRESS: HIDE_PROGRESS,
};

export const EMPLOYEES_ACTIONS = {
  GET_EMPLOYEES: GET_EMPLOYEES,
  SELECT_EMPLOYEE: SELECT_EMPLOYEE,
  GET_SUMMARY: GET_SUMMARY,
  SET_CONTENT_DATA_LOADING: SET_CONTENT_DATA_LOADING,
  SET_CONTENT_SUMMARY_LOADING: SET_CONTENT_SUMMARY_LOADING,
  SET_EMPLOYEE_CURRENT_ACTION: SET_EMPLOYEE_CURRENT_ACTION,
};

export const USERS_ACTIONS = {
  SET_USERS: SET_USERS,
  SELECT_USER: SELECT_USER,
  SET_USERS_DATA_LOADING: SET_USERS_DATA_LOADING,
  SET_USER_CURRENT_ACTION: SET_USER_CURRENT_ACTION,
};

export const DASHBOARD_ACTIONS = {
  SET_DASHBOARD_DATA: SET_DASHBOARD_DATA,
  SET_DASHBOARD_DATA_LOADING: SET_DASHBOARD_DATA_LOADING,
};

export const EMPLOYEE_DETAILS_ACTIONS = {
  SET_EMPLOYEE_INFO: SET_EMPLOYEE_INFO,
  SET_EMPLOYEE_MOVE_DETAILS: SET_EMPLOYEE_MOVE_DETAILS,
  SET_MOVE_TIMELINE: SET_MOVE_TIMELINE,
  SET_TICKET_REQUEST_DETAILS: SET_TICKET_REQUEST_DETAILS,
  SET_TICKET_TIMELINE: SET_TICKET_TIMELINE,
  SET_SHORT_STAY_REQUEST_DETAILS: SET_SHORT_STAY_REQUEST_DETAILS,
  SET_SHORT_STAY_TIMELINE: SET_SHORT_STAY_TIMELINE,
  SET_AIRPORT_TRANSFER_REQUEST_DETAILS: SET_AIRPORT_TRANSFER_REQUEST_DETAILS,
  SET_AIRPORT_TRANSFER_TIMELINE: SET_AIRPORT_TRANSFER_TIMELINE,
  SET_MOVE_TRACK_PATH: SET_MOVE_TRACK_PATH,
  SET_BULK_UPLOAD_STATUS: SET_BULK_UPLOAD_STATUS,
};

export const USER_DETAIL_ACTIONS = {
  SET_USER_INFO: SET_USER_INFO,
};
